import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Sidebar/sgds-sidebar";
import { register } from "../../utils/ce-registry";

register("sgds-sidebar", Component);

export default createComponent({
  react: React,
  tagName: "sgds-sidebar",
  elementClass: Component,
  events: {}
});
